<template>
    <div class="max-width-content">
        <!-- <trashed-message v-if="blogCategory.deleted_at" class="mb-6">
            This blogcategory has been deleted.
        </trashed-message> -->

        <div class="flex items-center justify-between">
            <breadcrumbs>
                <inertia-link :href="route('admin.blogcategories.index')">Blogrubrieken</inertia-link>
                <i class="fad fa-chevron-right"></i>
                {{ blogCategory.name | truncate(35) }}
            </breadcrumbs>

            <div v-if="!blogCategory.deleted_at">
                <link-button :href="route('admin.blogcategories.edit', blogCategory.id)" icon="pencil" class="bg-white">Wijzig</link-button>
                <confirm-button method="delete" :href="route('admin.blogcategories.destroy', blogCategory.id)" icon="trash" class="bg-white hover:bg-red-600 hover:text-white">Verwijder</confirm-button>
            </div>
        </div>

                <h1 class="text-5xl text-teal-800 mr-1 leading-tight mt-3">{{ blogCategory.name }}</h1>

                <div class="styled-content">
                    <div v-if="blogCategory.description" v-html="blogCategory.description"></div>
                    <!-- <div v-else>Er is nog geen beschrijving bij deze plaats.</div> -->
                </div>
            </div>
    </div>
</template>

<script>
import Layout from "@/admin/Shared/Layout";
import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import Breadcrumbs from "@/admin/Shared/Breadcrumbs";
import LinkButton from "@/admin/Shared/LinkButton";
import ConfirmButton from "@/admin/Shared/ConfirmButton";

export default {
    metaInfo: { title: "Companies" },

    layout: Layout,

    mixins: [Helpers],

    components: { Breadcrumbs, LinkButton, ConfirmButton },

    props: {
        blogCategory: {
            Type: Object
        }
    },
    data() {
        return {};
    },
    methods: {}
};
</script>
